/*
 * Copyright (c) 2019 Euro Games Technology - All rights reserved.
 *
 * File: JackpotRefContext.tsx
 *
 * Written by Stefan Atanasov <stefan.atanasov@egt-bg.com> on 07.08.23 11:17 am.
 * Last modified: 07.08.23 11:17 am.
 *
 * More information at: egt-bg.com
 */
import React, { useContext, useState } from 'react';
import { createContext } from 'react';

export const SectionContainerRefContext = createContext<ISectionContainerRefContext>({
    sectionContainerRef: null,
    setSectionContainerRef: null,
});

export const SectionContainerRefProvider = ({ value, children }: ISectionContainerRefProvider) => {
    const [sectionContainerRef, setSectionContainerRef] = useState(value);

    return (
        <SectionContainerRefContext.Provider value={{ sectionContainerRef, setSectionContainerRef }}>
            {children}
        </SectionContainerRefContext.Provider>
    );
};

export const useSectionContainerRef = (): [
    React.MutableRefObject<HTMLElement | null> | null,
    React.Dispatch<React.SetStateAction<React.MutableRefObject<HTMLElement>>>,
] => {
    const { sectionContainerRef, setSectionContainerRef } = useContext<ISectionContainerRefContext>(
        SectionContainerRefContext,
    );

    return [sectionContainerRef, setSectionContainerRef];
};

interface ISectionContainerRefContext {
    sectionContainerRef: React.MutableRefObject<HTMLElement | null> | null;
    setSectionContainerRef: any;
}

interface ISectionContainerRefProvider {
    value: null;
    children: any;
}
